import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { TAGS } from "./common/tags";
import { applyLoyaltyCampaignEndpoint } from "./endpoints/applyLoyaltyCampaign.endpoint";
import { getLoyaltyPointsEndpoint } from "./endpoints/getLoyaltyPoints.endpoint";
import { getLoyaltyReferralCustomerEndpoint } from "./endpoints/getLoyaltyReferralCustomer.endpoint";
import { getLoyaltyStatusEndpoint } from "./endpoints/getLoyaltyStatus.endpoint";
import { getLoyaltyTiersEndpoint } from "./endpoints/getLoyaltyTiers.endpoint";
import { getLoyaltyVouchersEndpoint } from "./endpoints/getLoyaltyVouchers.endpoint";
import { removeLoyaltyCampaignEndpoint } from "./endpoints/removeLoyaltyCampaign.endpoint";
import { updateLoyaltyReferralCodeEndpoint } from "./endpoints/updateLoyaltyReferralCode.endpoint";
import { verifyLoyaltyReferralCodeEndpoint } from "./endpoints/verifyLoyaltyReferralCode.endpoint";

export const loyaltyApiSlice = createApi({
  reducerPath: "loyaltyApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  tagTypes: [
    TAGS.LOYALTY_STATUS,
    TAGS.LOYALTY_POINTS,
    TAGS.LOYALTY_TIERS,
    TAGS.LOYALTY_VOUCHERS,
    TAGS.LOYALTY_REFERRAL,
  ],
  endpoints: (builder) => ({
    ...getLoyaltyStatusEndpoint(builder),
    ...getLoyaltyPointsEndpoint(builder),
    ...getLoyaltyTiersEndpoint(builder),
    ...getLoyaltyVouchersEndpoint(builder),
    ...getLoyaltyReferralCustomerEndpoint(builder),
    ...verifyLoyaltyReferralCodeEndpoint(builder),
    ...updateLoyaltyReferralCodeEndpoint(builder),
    ...applyLoyaltyCampaignEndpoint(builder),
    ...removeLoyaltyCampaignEndpoint(builder),
  }),
});

export const {
  useGetLoyaltyStatusQuery,
  useGetLoyaltyPointsQuery,
  useGetLoyaltyTiersQuery,
  useGetLoyaltyVouchersQuery,
  useLazyGetLoyaltyVouchersQuery,
  useGetLoyaltyReferralCustomerQuery,
  useVerifyLoyaltyReferralCodeMutation,
  useUpdateLoyaltyReferralCodeMutation,
  useApplyLoyaltyCampaignMutation,
  useRemoveLoyaltyCampaignMutation,
} = loyaltyApiSlice;
